import { BlockType } from '../../types/index.js';
import { AnnouncementBlock as Component } from './Block.js';
import { AnnouncementBlockSettings as Settings } from './Settings.js';
export const RegisteredAnnouncementBlock = (intl) => {
    const { $t } = intl;
    return {
        recommendedName: 'Announcement',
        Component,
        config: {
            type: BlockType.Block,
            usable: false,
            deprecated: true,
            displayName: $t({
                id: 'Blocks.Announcement.DisplayName',
                defaultMessage: 'Announcement',
            }),
            Settings,
            defaultProps: {
                align: 'center',
                viewStyle: 'simple',
                hidden: false,
            },
        },
    };
};
//# sourceMappingURL=registered.js.map